import { bsc, bscTestnet, celoAlfajores, goerli } from "viem/chains";

const chainsConfig = {
  chains: [bscTestnet],
  stakingContract: {
    [bscTestnet.id]: "0xA1e0C0c7Dfe8197ebBafCABF10B2D6cea9652bA1",
  } as Record<number, `0x${string}`>,
  tokenContract: {
    [bscTestnet.id]: "0xbbd07d25d9cb561976dc860677edf2c3998c0375",
  } as Record<number, `0x${string}`>,
};

export default chainsConfig;
